// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.

import { createSelector } from 'reselect'

import { fullSystemStateSelector } from './fullFileFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../types/system').Ideas} Ideas
 * @typedef {import('../types/system').Threads} Threads
 * @typedef {import('../types/system').PocketIdeasState} PocketIdeasState
 * @typedef {import('../types/plottr-in-your-pocket').UniversalIdeaId} UniversalIdeaId
 */

/**
 * @type {function(PlottrState): PocketIdeasState}
 */
const pocketIdeasStateSelector = createSelector(fullSystemStateSelector, ({ ideas }) => {
  return (
    ideas || {
      ideas: [],
      ideaToDisplay: null,
    }
  )
})

/**
 * @type {function(PlottrState): Ideas}
 */
export const ideasFromPocketSelector = createSelector(pocketIdeasStateSelector, ({ ideas }) => {
  return (
    ideas
      .filter(({ deleted }) => {
        return !deleted
      })
      .sort(
        (a, b) =>
          new Date(b.createdISOTimestamp).getTime() - new Date(a.createdISOTimestamp).getTime()
      ) || []
  )
})

/**
 * @type {function(PlottrState): (UniversalIdeaId | null)}
 */
export const pocketIdeaToDisplaySelector = createSelector(
  pocketIdeasStateSelector,
  ({ ideaToDisplay }) => {
    return ideaToDisplay ?? null
  }
)

/**
 * @type {function(PlottrState): Ideas}
 */
export const allPocketPhotoIdeas = createSelector(ideasFromPocketSelector, (ideas) => {
  return ideas.filter(({ kind }) => {
    return kind === 'photo'
  })
})

/**
 * @type {function(PlottrState): Threads}
 */
export const threadsFromPocketSelector = createSelector(pocketIdeasStateSelector, ({ threads }) => {
  return (
    threads
      .filter(({ deleted }) => {
        return !deleted
      })
      .sort((a, b) => new Date(b.isoTimestamp).getTime() - new Date(a.isoTimestamp).getTime()) || []
  )
})
